import request from "@/utils/request";
import URL from "@/api/baseUrl";

const basePath = `${URL.vip}/vip-bas-page-template`;

export default class VipPageTemplate {
  static getUserPageListInfo(params = {}) {
    return request.get(`${basePath}/getUserPageListInfo`, params);
  }

  static saveTemplateWithFields(data = {}) {
    return request.post(`${basePath}/saveTemplateWithFields`, data);
  }
}
